import { getSearchParam } from "./useLocation";

export const getUrls = () => {
    const protocol = window.location.protocol + "//";
    const hostname = window.location.hostname;

    if (hostname.includes("portal.prodeseg")) {
        return {
            api: protocol + "portal.prodeseg.com/efi",
            cotizadorUrl: protocol + "cotizadorvehiculos.prodeseg.com",
            cotizadorVamUrl: protocol + "cotizador-vam.prodeseg.com",
        };
    }
    if (hostname.includes("portal2.prodeseg")) {
        return {
            api: protocol + "portal2.prodeseg.com/efi",
            cotizadorUrl: protocol + "cotizadorvehiculos2.prodeseg.com",
            cotizadorVamUrl: protocol + "cotizador-vam2.prodeseg.com",
        };
    }
    return {
        api: "http://localhost:8080/efi",
        cotizadorUrl: "http://localhost:3001",
        cotizadorVamUrl: "http://localhost:3002",
    };
};

export const app = {
    name: "Asistencia Médica",
    prodeseg: true,
    showPerfil: false,
    showLinkToWeb: true,
    linkToWeb: "https://www.google.com.ec", // todo de alguna manera saber la web a donde regresa
};

export const pos = (text, pattern) => {
    return text.indexOf(pattern);
};

export const image_file_size = 5 * 1024 * 1024; // 1MB

export const isMobile = () => {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
};

export const filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    return row[id] ? slugify(String(row[id].toLowerCase())).indexOf(slugify(filter.value.toLowerCase())) >= 0 : true;
};

const slugify = str => {
    let map = {
        "-": "",
        a: "á|à|ã|â|À|Á|Ã|Â",
        e: "é|è|ê|É|È|Ê",
        i: "í|ì|î|Í|Ì|Î",
        o: "ó|ò|ô|õ|Ó|Ò|Ô|Õ",
        u: "ú|ù|û|ü|Ú|Ù|Û|Ü",
        c: "ç|Ç",
        n: "ñ|Ñ",
    };

    str = str.toLowerCase();

    for (let pattern in map) {
        str = str.replace(new RegExp(map[pattern], "g"), pattern);
    }

    return str;
};

export const has_role = (user, rol) => {
    return user.roles.indexOf(rol) >= 0;
};

export const getRandom = () => {
    return Math.floor(Math.random() * (17 - 1)) + 1;
};

export const getRandomF = () => {
    return Math.floor(Math.random() * (1000 - 1)) + 1;
};

export const EFI_MODULES = {
    GEN: "gen",
    VAM: "vam",
};

export const redirectToCotizador = () => {
    const idZoho = getSearchParam("idZoho");
    if (!idZoho) return;
    const from = getSearchParam("from");
    if (from === "vam") return window.location.replace(`${getUrls().cotizadorVamUrl}/login?idZoho=${idZoho}`);
    window.location.replace(`${getUrls().cotizadorUrl}/cotizar?idZoho=${idZoho}`);
};
